import React,{useState,useEffect} from 'react'
import {useNavigate} from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { v4 as uuidv4 } from "uuid";
import 'react-toastify/dist/ReactToastify.css';
import PayPalButton from '../Paypal/PayPalButton';
import {URL} from '../Helper/helper'
import './RegisterComponent.css'
import PaymentDetails from './PaymentDetails';
import { sendBookingConfirmationEmail } from '../ServiceCalls/ApiCalls';


function RegisterComponent({addBookings,togglePermBookingView,totalPrice,courtSelected,clearBookingArr}) {

  const user_info = localStorage.getItem('user') || null
  const navigate = useNavigate();
  const[firstName,setFirstName]= useState('')
  const[lastName,setLastName]= useState('')
  const[email,setEmail]= useState('')
  const[contact,setContact]= useState('')
  const[bookingID,setBookingID] = useState('')
  //const[address,setAddress]= useState('')
  const[userName,setUserName]= useState('')
  //const[password,setPassword]= useState('')
  const[paymentMode,setPaymentMode] = useState('')
  const[playersCount,setPlayersCount] = useState(0)
  const[discountValue,setDiscountValue] = useState(0)
  const[grandTotal,setgrandTotal] = useState(0)
  const[discountPrice,setDiscountPrice] = useState(0)
  const[purchaseItems,setPurchaseItems]= useState([])
  const[status,setStatus] = useState(false)
  const[paymentDetails,setPaymentDetails] = useState({})
  const[invalidUserName,setInvalidUserName] = useState(false)
  const[registerStatus,setRegisterStatus] = useState(false)
  const[errorMsg,setErrorMsg] = useState(false)
  const[txnBookingID,setTxnBookingID] = useState('')
  const[disablePayPalBtn,setDisablePayPalBtn] = useState(false)
  const[isBookingInProgress,setIsBookingInProgress] = useState(false)
  const[failedBookingsList,setFailedBookingsList] = useState([])
  const [successfulBookingsForGuest, setSuccessfulBookingsForGuest] = useState([]);
  const [showPayPalButtons, setShowPayPalButtons] = useState(false);


  useEffect(() =>{
    console.log('Bookings []',addBookings)

    setStatus(true)
    const booking_id = uuidv4().replace(/\D/g, "").slice(0, 5);
    console.log('Unique ID',booking_id);
    setTxnBookingID(booking_id);
    handlePurchaseItemsList(booking_id);
  },[])

  useEffect(() => {
    // Initialize grandTotal and discountPrice based on totalPrice
    if (totalPrice > 0) {
      setgrandTotal(totalPrice);
      setDiscountPrice(totalPrice);
    }
  }, [totalPrice]);

  const handlePurchaseItemsList = (booking_id) => {

    const itemsPurchased = addBookings.map(item => {
        return {
            name:item.booking_item,
            sku: booking_id,
            quantity:1,
            unit_amount:{
                currency_code: "AUD",
                value:item.booking_price
            }
        }
    });
    setPurchaseItems(itemsPurchased)
  }
  const handleOnChange = e => {
    e.preventDefault()
    const{name,value} = e.target;

    switch(name){
        case 'firstName':
            setFirstName(value)
            break;
        case 'lastName':
            setLastName(value)
            break;
        case 'email':
            setEmail(value)
            break;
        case 'contact':

            const phonePattern = /^[+]?[0-9]+$/;
            // Check if the input matches the phone number pattern
            const isValidPhoneNumber = phonePattern.test(Number(value));

            // Convert input to a string (if it's not already)
            if(isValidPhoneNumber) {
                const convertedString = String(value);
                setContact(convertedString)
            }
            break;
        case 'playersCount':
            setPlayersCount(value)
            break;

        case 'userName':
            const emailOrURLPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            if (emailOrURLPattern.test(value)) {
                setInvalidUserName(true); // Invalid username (email or URL)
            } else {
                setInvalidUserName(false); // Valid username
            }
            setUserName(value);
            break;
        default :
            break;
    }

  }
  const handleSubmit = async(e) =>{

       e.preventDefault()
       if(user_info !== null && !isBookingInProgress){
            // For admin/logged-in users, directly attempt to save bookings
            const { successCount, failedBookingsTotal, adjustedGrandTotal, allBookingsProcessed, successfullyBooked } = await handleSaveBookings();

            if (allBookingsProcessed && successCount > 0) {
                setRegisterStatus(true);
                toast.success('🦄 Wow Booking Successful!', {
                    position: "top-right", autoClose: 3000, hideProgressBar: false,
                    closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined, theme: "colored",
                });
                // Consolidate and send a single email notification for all successfully booked items
                if (successfullyBooked.length > 0) {
                    const firstBooking = successfullyBooked[0];
                    const bookingsListHtml = successfullyBooked.map(booking => `
                        <li>
                            <strong>Court:</strong> ${booking.booking_item}, 
                            <strong>Date:</strong> ${booking.booking_date}, 
                            <strong>Time:</strong> ${booking.booking_time_start} - ${booking.booking_time_end}, 
                            <strong>Price:</strong> A$${booking.total_price.toFixed(2)}
                        </li>
                    `).join('');

                    const emailBody = `
                        <p>Dear ${firstBooking.firstName} ${firstBooking.lastName},</p>
                        <p>Your bookings have been successfully confirmed!</p>
                        <p><strong>Booking Details:</strong></p>
                        <ul>
                            ${bookingsListHtml}
                        </ul>
                        <p>Total Amount Paid: A$${adjustedGrandTotal.toFixed(2)}</p>
                        <p>Contact: ${firstBooking.contact}</p>
                        <p>Thank you for your booking!</p>
                    `;

                    const emailSubject = `Booking Confirmation - ${successfullyBooked.length} Bookings`;

                    const emailDetails = {
                        recipient: firstBooking.email,
                        subject: emailSubject,
                        htmlBody: emailBody,
                        // You might want to include a summary of booking details here instead of a full booking object
                        // For now, let's just send the necessary email fields
                        bookingsSummary: successfullyBooked.map(b => ({ // Sending a summary instead of all details of the first booking
                            booking_item: b.booking_item,
                            booking_date: b.booking_date,
                            booking_time_start: b.booking_time_start,
                            booking_time_end: b.booking_time_end,
                            total_price: b.total_price
                        }))
                    };
                    console.log('Attempting to send a single email for normal booking (admin flow):', emailDetails);
                    await sendBookingConfirmationEmail(emailDetails);
                }
                clearBookingArr();
                togglePermBookingView(true); // Assuming this navigates to a success page or clears the form
            } else if (allBookingsProcessed && successCount === 0 && failedBookingsTotal > 0) {
                // All bookings failed, but already handled by toast in handleSaveBookings
                // Just clear the form or navigate if necessary
                clearBookingArr();
            }
            // If not allBookingsProcessed, handleSaveBookings already logged the issue
       } else if (user_info === null && !isBookingInProgress) {
            // For guest users, trigger PayPal process by enabling PayPal button
            // First, attempt to save bookings to get the adjusted total
            const { successCount, failedBookingsTotal, adjustedGrandTotal, allBookingsProcessed, successfullyBooked } = await handleSaveBookings();

            if (allBookingsProcessed && successCount > 0) {
                // Only enable PayPal if there are successful bookings to pay for
                setDisablePayPalBtn(false); // This will control the actual button's disabled state *within* the PayPal component
                setShowPayPalButtons(true); // Make PayPal buttons visible
                // Update grandTotal/discountPrice to reflect deductions if any failed
                setgrandTotal(adjustedGrandTotal);
                setDiscountPrice(adjustedGrandTotal);
                setPurchaseItems(successfullyBooked.map(item => ({
                    name: item.booking_item,
                    sku: txnBookingID,
                    quantity: 1,
                    unit_amount: {
                        currency_code: "AUD",
                        value: item.booking_price
                    }
                })));
                setSuccessfulBookingsForGuest(successfullyBooked);

                // Now allow PayPal button to be visible and clicked
                // The PayPalButton component itself will manage its disabled state based on 'disablePayPalBtn' prop
            } else {
                // All bookings failed or no bookings to proceed with payment
                setDisablePayPalBtn(true);
                setShowPayPalButtons(false); // Hide PayPal buttons
                // handleSaveBookings already shows a toast for failed bookings
            }
       }

  }
  const displayBtnText = () => {
        const btnText =  user_info === null ? 'Proceed to Pay': 'Book';
        return btnText;
  }
  const handlePaymentSuccess = async(details) => {
    // Logic to handle successful payment
    console.log('handlePaymentSuccess triggered with details:', details);
    if(details.status === 'COMPLETED' && !isBookingInProgress){
       console.log('Payment Details (COMPLETED) and !isBookingInProgress is true',details)
       setPaymentDetails({...details})
       setDisablePayPalBtn(false)
       setStatus(false)
       setRegisterStatus(true)
       // After successful payment, the bookings should have already been processed by handleSaveBookings (when PayPal button was enabled)
       // We just need to clear the form and navigate
       toast.success('Payment successful! Your booking is confirmed.', {
            position: "top-right", autoClose: 3000, hideProgressBar: false,
            closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined, theme: "colored",
        });
        // Send a single email notification for all successful guest bookings
        console.log('Checking successfulBookingsForGuest length:', successfulBookingsForGuest.length);
        if (successfulBookingsForGuest.length > 0) {
            console.log('Constructing email for guest user with successfulBookingsForGuest:', successfulBookingsForGuest);
            const firstBooking = successfulBookingsForGuest[0];
            const bookingsListHtml = successfulBookingsForGuest.map(booking => `
                <li>
                    <strong>Court:</strong> ${booking.booking_item}, 
                    <strong>Date:</strong> ${booking.booking_date}, 
                    <strong>Time:</strong> ${booking.booking_time_start} - ${booking.booking_time_end}, 
                    <strong>Price:</strong> A$${booking.total_price.toFixed(2)}
                </li>
            `).join('');

            const emailBody = `
                <p>Dear ${firstBooking.firstName} ${firstBooking.lastName},</p>
                <p>Your bookings have been successfully confirmed!</p>
                <p><strong>Booking Details:</strong></p>
                <ul>
                    ${bookingsListHtml}
                </ul>
                <p>Total Amount Paid: A$${(discountPrice > 0 ? discountPrice : grandTotal).toFixed(2)}</p>
                <p>Contact: ${firstBooking.contact}</p>
                <p>Thank you for your booking!</p>
            `;

            const emailSubject = `Booking Confirmation - ${successfulBookingsForGuest.length} Bookings`;

            const emailDetails = {
                recipient: firstBooking.email,
                subject: emailSubject,
                htmlBody: emailBody,
                bookingsSummary: successfulBookingsForGuest.map(b => ({
                    booking_item: b.booking_item,
                    booking_date: b.booking_date,
                    booking_time_start: b.booking_time_start,
                    booking_time_end: b.booking_time_end,
                    total_price: b.total_price
                }))
            };
            console.log('Final emailDetails for guest user:', emailDetails);
            await sendBookingConfirmationEmail(emailDetails);
        } else {
            console.warn('No successful bookings found for guest user to send email notification.');
        }
       clearBookingArr();
       togglePermBookingView(true);
    } else {
        console.warn('handlePaymentSuccess: Condition (details.status === \'COMPLETED\' && !isBookingInProgress) not met.', {details: details, isBookingInProgress: isBookingInProgress});
    }

  };

  const handleSaveBookings = async(details = null) =>{

        // Prevent multiple simultaneous booking attempts
        if (isBookingInProgress) {
            console.log('Booking already in progress, skipping duplicate call');
            // Return current grandTotal if booking is in progress to avoid re-calculation issues
            return { successCount: 0, failedBookingsTotal: 0, adjustedGrandTotal: grandTotal, allBookingsProcessed: false };
        }

        setIsBookingInProgress(true);

        let c = 0;
        let date = new Date();
        let b_date = date.toJSON().split('T')[0];
        let b_time_stamp = date.toJSON().split('T')[1];
        let b_time = b_time_stamp.split(':')[0] + ':' + b_time_stamp.split(':')[1];

        const seenKeys = new Set();
        const duplicates = [];

        const newBookingArr = addBookings.map((b, i) => {
            b.firstName = firstName
            b.lastName = lastName
            b.email = email
            b.contact = contact
            b.userName = userName
            b.booking_status = user_info !== null ? paymentMode : 'Online'
            b.total_price = discountPrice > 0 ? discountPrice : totalPrice
            b.grand_total = grandTotal === 0 ? totalPrice : grandTotal
            b.discount = discountValue
            b.net_price = discountPrice === 0 ? totalPrice : discountPrice
            b.playersCount = playersCount
            b.createdBy = b_date + '|' + b_time
            b.bookingID = txnBookingID
            return b;
        })

        const uniqueArr = newBookingArr.filter(item => {
            const key = `${item.booking_date}-${item.booking_time_start}-${item.booking_time_end}-${item.booking_item}-${item.bookingID}`;
            if (seenKeys.has(key)) {
                duplicates.push(item);
                return false;
            } else {
                seenKeys.add(key);
                return true;
            }
        });


        try {
               const requests = uniqueArr.map(async (booking) => {
                    try {
                        const response = await fetch(`${URL}/bookings`, {
                            method: "POST",
                            headers: { "Content-Type": "application/json" },
                            body: JSON.stringify(booking),
                        });

                        return { booking, success: response.ok };
                    } catch (err) {
                        return { booking, success: false, error: err.message };
                    }
                });

                console.log('API Requests',requests);
                const results = await Promise.allSettled(requests);

                let successCount = 0;
                let failedBookingsTotal = 0;
                const successfullyBooked = [];
                const currentlyFailedBookings = [];

                results.forEach(result => {
                    if (result.status === 'fulfilled' && result.value.success) {
                        successCount++;
                        successfullyBooked.push(result.value.booking);
                    } else {
                        const bookingPrice = result.status === 'fulfilled' && result.value.booking ? parseFloat(result.value.booking.booking_price) : 0;
                        failedBookingsTotal += bookingPrice;
                        currentlyFailedBookings.push(result.status === 'fulfilled' ? result.value.booking : result.reason?.booking);
                    }
                });

                if (currentlyFailedBookings.length > 0) {
                    console.error("Failed Bookings:", currentlyFailedBookings);
                    setFailedBookingsList(currentlyFailedBookings);
                    setErrorMsg(true);
                    toast.error(`❌ ${currentlyFailedBookings.length} booking(s) failed. Please check the Failed Bookings page from your dashboard.`, {
                        position: "top-right", autoClose: 5000, hideProgressBar: false,
                        closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined, theme: "colored",
                    });
                }
                
                // Deduct failed bookings total from grandTotal and net_price for current attempt
                let currentGrandTotal = grandTotal === 0 ? totalPrice : grandTotal;
                let currentNetPrice = discountPrice === 0 ? totalPrice : discountPrice;

                const adjustedGrandTotal = currentGrandTotal - failedBookingsTotal;
                const adjustedNetPrice = currentNetPrice - failedBookingsTotal;

                setgrandTotal(adjustedGrandTotal);
                setDiscountPrice(adjustedNetPrice); // Assuming discountPrice also reflects the net price after all deductions

                return { successCount, failedBookingsTotal, adjustedGrandTotal, allBookingsProcessed: true, successfullyBooked };
            }
        catch(ex) {
            console.log('Exception during booking attempts:',ex.message);
            toast.error('An error occurred during booking.', {
                position: "top-right", autoClose: 5000, hideProgressBar: false,
                closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined, theme: "colored",
            });
            return { successCount: 0, failedBookingsTotal: totalPrice, adjustedGrandTotal: 0, allBookingsProcessed: false };
        } finally {
            setIsBookingInProgress(false);
        }

  }


const handlePaymentError = (error) => {
    // Logic to handle payment
    console.log('Payment Error',error)

};




const applyDiscount = (e) =>{
    e.preventDefault()
    let discountAmount = Math.abs(discountValue / 100 );
    let d_price = grandTotal * discountAmount ; // Use current grandTotal
    let priceAfterDiscount = grandTotal - d_price; // Use current grandTotal
    setgrandTotal(priceAfterDiscount) // Update grandTotal with discounted price
    setDiscountPrice(priceAfterDiscount)
}
const toggleButtonsView = () => {

    if( user_info !== null) {
        if (registerStatus) {
            return true;
        }
    }
    else {
        if(registerStatus && paymentDetails.status === 'COMPLETED') {
            return true;
        }
    }
    return false;

}
  return (
    <div className='register-page'>
      <div className="container admin-container">
        {/* Register Header */}
        <div className="register-header">
          {status && (
            <a
              className="back-link"
              onClick={() => togglePermBookingView(registerStatus ? true : false)}
              href="#">
              <i className="fa fa-arrow-left me-2"></i>
              Back to Bookings
            </a>
          )}
          <h2>
            <i className="fa fa-user-plus text-primary"></i>
            Court Registration
          </h2>
          <p>Complete your booking details and secure your court reservation</p>
        </div>

        {/* Register Form */}
        <div className="register-form-container">
          <form className="register-form" onSubmit={handleSubmit} autoComplete="off">
            <div className="row">
              {/* Personal Information Section */}
              <div className="col-12 col-lg-4">
                <div className="form-section">
                  <h5 className="section-title">
                    <i className="fa fa-user"></i>
                    Personal Information
                  </h5>

                  <div className="form-group">
                    <label htmlFor="fname" className="form-label">
                      <i className="fa fa-user"></i>
                      First Name
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="fname"
                      name="firstName"
                      placeholder="Enter your first name"
                      required
                      value={firstName}
                      onChange={e => handleOnChange(e)}
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="lname" className="form-label">
                      <i className="fa fa-user"></i>
                      Last Name
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="lname"
                      name="lastName"
                      placeholder="Enter your last name"
                      required
                      value={lastName}
                      onChange={handleOnChange}
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="email" className="form-label">
                      <i className="fa fa-envelope"></i>
                      Email Address
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      id="email"
                      name="email"
                      placeholder="Enter your email address"
                      required
                      value={email}
                      onChange={handleOnChange}
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="contact" className="form-label">
                      <i className="fa fa-phone"></i>
                      Contact Number
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="contact"
                      name="contact"
                      placeholder="Enter your contact number"
                      required
                      value={contact}
                      onChange={handleOnChange}
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="username" className="form-label">
                      <i className="fa fa-address-book"></i>
                      Username
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="username"
                      name="userName"
                      placeholder="Enter your username (not an email)"
                      required
                      value={userName}
                      onChange={handleOnChange}
                    />
                    {invalidUserName && (
                      <div className="error-message">
                        <i className="fa fa-exclamation-circle me-1"></i>
                        Usernames cannot be email addresses
                      </div>
                    )}
                  </div>
                </div>
              </div>
              {/* Booking Details Section */}
              <div className="col-12 col-lg-4">
                <div className="form-section">
                  <h5 className="section-title">
                    <i className="fa fa-calendar"></i>
                    Booking Details
                  </h5>

                  <div className="form-group">
                    <label htmlFor="playerscount" className="form-label">
                      <i className="fa fa-users"></i>
                      Number of Players
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      value={playersCount}
                      onChange={handleOnChange}
                      id="playerscount"
                      name="playersCount"
                      required
                      min="1"
                      max="10"
                      placeholder="Enter number of players"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="courtno" className="form-label">
                      <i className="fa fa-map-marker"></i>
                      Court Number
                    </label>
                    <input
                      type="text"
                      name="courtno"
                      id="courtno"
                      className="form-control"
                      value={courtSelected}
                      readOnly
                    />
                  </div>

                  {user_info !== null && (
                    <div className="form-group">
                      <label htmlFor="discount" className="form-label">
                        <i className="fa fa-percent"></i>
                        Discount Percentage
                      </label>
                      <div className="discount-container">
                        <div className="discount-input">
                          <input
                            type="number"
                            name="discount"
                            id="discount"
                            className="form-control"
                            value={discountValue}
                            onChange={e => setDiscountValue(e.target.value)}
                            placeholder="Enter discount %"
                            min="0"
                            max="100"
                          />
                        </div>
                        <button
                          type="button"
                          className="discount-btn"
                          onClick={applyDiscount}
                        >
                          Apply
                        </button>
                      </div>
                    </div>
                  )}

                  <div className="form-group">
                    <label htmlFor="totalprice" className="form-label">
                      <i className="fa fa-dollar"></i>
                      Total Price
                    </label>
                    <input
                      type="text"
                      name="totalprice"
                      id="totalprice"
                      className="form-control"
                      value={`A$${discountValue > 0 ? discountPrice.toFixed(2) : totalPrice.toFixed(2)}`}
                      readOnly
                    />
                  </div>

                  {user_info !== null && (
                    <div className="form-group">
                      <label htmlFor="paymentmode" className="form-label">
                        <i className="fa fa-credit-card"></i>
                        Payment Mode
                      </label>
                      <select
                        id="paymentmode"
                        className="form-control"
                        onChange={e => setPaymentMode(e.target.value)}
                        value={paymentMode}
                      >
                        <option value="">-- Select Payment Mode --</option>
                        <option value="UnPaid">Unpaid</option>
                        <option value="EFTPOS">EFTPOS</option>
                        <option value="Cash">Cash</option>
                        <option value="Complimentary">Complimentary</option>
                      </select>
                    </div>
                  )}
                </div>
              </div>
              {/* Payment Section */}
              <div className="col-12 col-lg-4">
                <div className="form-section">
                  <h5 className="section-title">
                    <i className="fa fa-credit-card"></i>
                    Payment
                  </h5>

                  <div className="payment-section">
                    <div className="payment-content">
                      {user_info === null && showPayPalButtons && !isBookingInProgress ? (
                        <div>
                          <h6 className="mb-3">
                            <i className="fa fa-paypal text-primary me-2"></i>
                            Secure Online Payment
                          </h6>
                          <PayPalButton
                            amount={discountPrice > 0 ? discountPrice : grandTotal}
                            purchaseItems={purchaseItems}
                            onSuccess={handlePaymentSuccess}
                            txnBookingID={txnBookingID}
                            onError={handlePaymentError}
                          />
                        </div>
                      ) : isBookingInProgress && user_info === null ? (
                        <div className="processing-alert">
                          <i className="fa fa-spinner fa-spin me-2"></i>
                          Processing your booking, please wait...
                        </div>
                      ) : user_info !== null ? (
                        <div className="text-center">
                          <i className="fa fa-user-shield fa-3x text-success mb-3"></i>
                          <h6>Admin Booking</h6>
                          <p className="text-muted mb-0">
                            Payment will be processed based on selected payment mode
                          </p>
                        </div>
                      ) : (
                        <div className="text-center">
                          <i className="fa fa-lock fa-3x text-muted mb-3"></i>
                          <h6>Secure Payment</h6>
                          <p className="text-muted mb-0">
                            Complete the form to proceed with payment
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Submit Section */}
            <div className="submit-section">
              {status && (
                <button
                  className="submit-btn"
                  type="submit"
                  disabled={!status || isBookingInProgress || showPayPalButtons}
                >
                  {displayBtnText()}
                </button>
              )}

              {isBookingInProgress && (
                <div className="processing-alert mt-3">
                  <i className="fa fa-spinner fa-spin me-2"></i>
                  Processing your booking, please wait...
                </div>
              )}
            </div>
          </form>
        </div>

        {/* Payment Details */}
        {paymentDetails.status === 'COMPLETED' && (
          <PaymentDetails details={paymentDetails} />
        )}

        {/* More Bookings Section */}
        {toggleButtonsView() && (
          <div className="more-bookings-section">
            <button
              className="more-bookings-btn"
              onClick={() => togglePermBookingView(registerStatus ? true : false)}
            >
              <i className="fa fa-plus me-2"></i>
              More Bookings
            </button>
          </div>
        )}

        <ToastContainer />
      </div>
    </div>
  )
}

export default RegisterComponent